import ApiService from '@/services/api.service.js';
import {TokenService} from '@/services/storage.service.js';


class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

const AuthService = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns access_token
   * @throws AuthenticationError
   **/
  login: async function (email, password) {
    const requestData = {
      method: 'post',
      url: "/auth/login",
      data: {
        email: email,
        password: password
      }
    }

    try {
      const response = await ApiService.customRequest(requestData)

      TokenService.saveToken(response.data.accessToken)
      ApiService.setHeader()

      // ApiService.mount401Interceptor();

      return response.data.access_token
    } catch (error) {
      throw new AuthenticationError(error.status, error.data.message)
    }
  },

  register: function (data) {
    return ApiService.post('/auth/register', data);
  },

  confirmEmail: function (token) {
    return ApiService.get('/auth/register/confirm/email/' + token);
  },

  resendConfirmEmail: function () {
    return ApiService.get('/auth/register/confirm/resend-email');
  },

  requestResetPassword: function (data) {
    return ApiService.post('/auth/password/forgot', data);
  },

  submitResetPassword: function (data) {
    return ApiService.post('/auth/password/reset', data);
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   **/
  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.removeToken()
    ApiService.removeHeader()
  }
}

export default AuthService

export {AuthService, AuthenticationError}